var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "card text-center col-sm-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Telecounselling Project")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "card-text"
  }, [_vm._v(" Also know as 'Hridaya Project' is aimed at reducing transmission of HIV/AIDS among Injecting Drug Users (IDU's) through awareness campaings and medical support. It is implemented by the India HIV/AIDS Alliance. This project was implemented under\n        FCRA category from 2012 - 2016.\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning showGallery",
    on: {
      "click": _vm.visibleGallery
    }
  }, [_vm._v("Show Gallery")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated slideInUp",
      "leave-active-class": "animated fadeOutDown",
      "appear": ""
    }
  }, [(_vm.showGallery) ? _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Gallery is coming soon!")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-lg",
    attrs: {
      "id": "second-btn"
    },
    on: {
      "click": _vm.hideGallery
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close",
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1744b154","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/Telecounselling/Telecounselling.vue
// module id = jwj7
// module chunks = 0